import React from 'react';
import { Text } from '../../../CommonComponents/OPL/Text/Text';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { RefreshButton } from '../RefreshButton/RefreshButton';

interface Props {
  label: string;
  subLabel: string;
  isHighlighted?: boolean;
}

export const MobileHeader = ({ label, subLabel, isHighlighted }: Props) => {
  return (
    <Box display="flex" alignItems="center" justifyContent="space-between">
      <Box mr="8">
        <Text isOverflowWrap variant="smallCaps">
          {label}
        </Text>

        <Text fontSize="small" color={isHighlighted ? 'primary.500' : 'neutral.500'}>
          {subLabel}
        </Text>
      </Box>

      <RefreshButton />
    </Box>
  );
};
